import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const HORIZONTAL_CONTAINER_MAX_WIDTH = 1280;
const HorizontalContainer = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    marginInline: "auto",
    maxInlineSize: `${HORIZONTAL_CONTAINER_MAX_WIDTH}px`,
    paddingInline: isMobile ? '400' : '800',
    children: children
  });
};
export default HorizontalContainer;